(function () {
  'use strict';

  var audio = document.getElementById('tm-global-audio');
  var sticky = document.getElementById('tm-sticky');
  if (!audio || !sticky) return;

  var btn = sticky.querySelector('.tm-sticky__btn');
  var closeBtn = sticky.querySelector('.tm-sticky__close');
  var progress = sticky.querySelector('.tm-sticky__progress');
  var bar = sticky.querySelector('.tm-sticky__bar');
  var buf = sticky.querySelector('.tm-sticky__buf');
  var curEl = sticky.querySelector('.tm-sticky__cur');
  var durEl = sticky.querySelector('.tm-sticky__dur');
  var titleEl = sticky.querySelector('.tm-sticky__product');

  var state = {
    rafId: null,
    isSeeking: false,
    pendingSeek: null,
    src2: null,
    intentPlay: false,
    desiredSrc: null
  };

  function clamp(n, a, b){ return Math.min(b, Math.max(a, n)); }

  function fmt(sec){
    sec = Math.max(0, sec || 0);
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function showSticky(){ sticky.classList.remove('is-hidden'); }
  function hideSticky(){ sticky.classList.add('is-hidden'); }

  function setPressed(isPlaying){
    btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
  }

  function setLoading(on){
    sticky.classList.toggle('is-loading', !!on);
  }

  function setBuffering(on){
    sticky.classList.toggle('is-buffering', !!on);
  }

  function ensureAudioAttrs(){
    try{
      audio.preload = audio.preload || 'metadata';
      audio.playsInline = true;
      audio.setAttribute('playsinline','');
      audio.setAttribute('webkit-playsinline','');
    }catch(e){}
  }

  function setDurationUI(){
    durEl.textContent = audio.duration ? fmt(audio.duration) : '--:--';
  }

  function setBarPercent(p){
    if (bar) bar.style.width = p + '%';
    if (progress) progress.setAttribute('aria-valuenow', String(Math.round(p)));
  }

  function setCurText(sec){
    if (curEl) curEl.textContent = fmt(sec);
  }

  function setProgressUI(){
    var p = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
    setBarPercent(isFinite(p) ? p : 0);
    setCurText(audio.currentTime);
  }

  function setBufferedUI(){
    if (!buf) return;
    var dur = audio.duration;
    if (!dur || !isFinite(dur) || !audio.buffered || audio.buffered.length === 0){
      buf.style.width = '0%';
      return;
    }

    var end = 0;
    try{
      var ct = audio.currentTime || 0;
      for (var i=0;i<audio.buffered.length;i++){
        var s = audio.buffered.start(i);
        var e = audio.buffered.end(i);
        if (ct >= s && ct <= e){ end = e; break; }
        if (e > end) end = e;
      }
    }catch(e){
      buf.style.width = '0%';
      return;
    }

    buf.style.width = clamp((end/dur)*100,0,100) + '%';
  }

  function stopRaf(){
    if (!state.rafId) return;
    cancelAnimationFrame(state.rafId);
    state.rafId = null;
  }

  function startRaf(){
    stopRaf();
    var tick = function(){
      if (!state.isSeeking){
        setProgressUI();
        setBufferedUI();
      }
      if (!audio.paused && !audio.ended){
        state.rafId = requestAnimationFrame(tick);
      } else {
        state.rafId = null;
      }
    };
    state.rafId = requestAnimationFrame(tick);
  }

  function applySeek(t){
    try{
      if (typeof audio.fastSeek === 'function') audio.fastSeek(t);
      else audio.currentTime = t;
    }catch(e){}
  }

  function getRatioFromClientX(x){
    var rect = progress.getBoundingClientRect();
    var w = rect.width || 1;
    return clamp((x - rect.left)/w,0,1);
  }

  function previewAt(x){
    var dur = audio.duration;
    if (!dur || !isFinite(dur)) return;
    var r = getRatioFromClientX(x);
    setBarPercent(r*100);
    setCurText(r*dur);
  }

  function commitAt(x){
    var dur = audio.duration;
    if (!dur || !isFinite(dur)) return;

    var r = getRatioFromClientX(x);
    var t = r * dur;

    setBarPercent(r*100);
    setCurText(t);

    state.pendingSeek = t;
    setLoading(true);
    setBuffering(true);

    applySeek(t);
    setProgressUI();
  }

  function settleIfMatches(){
    if (state.pendingSeek == null || !audio.duration) return;
    var diff = Math.abs((audio.currentTime||0) - state.pendingSeek);
    if (diff < 0.75){              // <- мягче для iOS
      state.pendingSeek = null;
      setLoading(false);
    }
  }

  function safePlay(){
    var p = audio.play();
    if (p && p.catch){
      p.catch(function(){
        state.intentPlay = false;
        setLoading(false);
        setBuffering(false);
        syncGridButtons();
      });
    }
  }

  function normSrc(s){ return (s||'').trim(); }

  function setGridBtnState(el, isPlaying){
    if (!el) return;
    el.classList.toggle('is-playing', !!isPlaying);
    el.setAttribute('aria-pressed', isPlaying?'true':'false');
  }

  function getTriggerSrc(el){
    return normSrc(el.getAttribute('data-src') || el.getAttribute('data-audio-src'));
  }

  function getActiveSrc(){
    return normSrc(state.desiredSrc) ||
           normSrc(audio.currentSrc) ||
           normSrc(audio.src);
  }

  function syncGridButtons(){
    var activeSrc = getActiveSrc();
    var isPlaying = !audio.paused && !audio.ended;
    var list = document.querySelectorAll('.tm-audio-trigger');

    for (var i=0;i<list.length;i++){
      var t = list[i];
      var s = getTriggerSrc(t);
      var active = activeSrc && s && s === activeSrc;
      setGridBtnState(t, active && isPlaying);
    }
  }

  function setSourceAndMaybePlay(src, src2, title){
    if (!src) return;

    ensureAudioAttrs();
    showSticky();

    if (titleEl) titleEl.textContent = title || 'Playing preview';

    state.src2 = src2 || null;
    state.intentPlay = true;

    var current = getActiveSrc();
    if (current === src && !audio.error){
      if (audio.paused || audio.ended){
        if (audio.ended) audio.currentTime = 0;
        safePlay();
      }
      syncGridButtons();
      return;
    }

    state.desiredSrc = src;

    setLoading(true);
    setBuffering(true);
    setPressed(false);

    audio.src = src;
    audio.load();
    syncGridButtons();
  }

  // ------------------------
  // GRID BUTTON
  // ------------------------
  document.addEventListener('click', function(e){
    var root = e.target.closest('.tm-audio-trigger');
    if (!root) return;

    e.preventDefault();

    var src  = normSrc(root.getAttribute('data-src')  || root.getAttribute('data-audio-src'));
    var src2 = normSrc(root.getAttribute('data-src2') || root.getAttribute('data-audio-src2'));
    var title = root.getAttribute('data-title') ||
                root.getAttribute('data-product-title') ||
                document.title;

    var active = getActiveSrc();

    if (src && active && src === active && !audio.error){
        showSticky();
      if (audio.paused || audio.ended){
        state.intentPlay = true;
        if (audio.ended) audio.currentTime = 0;
        setLoading(true);
        setBuffering(true);
        safePlay();
      } else {
        state.intentPlay = false;
        audio.pause();
      }
      syncGridButtons();
      return;
    }

    setSourceAndMaybePlay(src, src2, title);
  }, {capture:true});

  // ------------------------
  // STICKY BUTTON
  // ------------------------
  btn.addEventListener('click', function(e){
    e.preventDefault();
    state.intentPlay = false;

    if (audio.paused || audio.ended){
      state.intentPlay = true;
      if (audio.ended) audio.currentTime = 0;
      setLoading(true);
      setBuffering(true);
      safePlay();
    } else {
      audio.pause();
    }
    syncGridButtons();
  });

  closeBtn.addEventListener('click', function(e){
    e.preventDefault();
    state.intentPlay = false;
    audio.pause();
    hideSticky();
    syncGridButtons();
  });

  // ------------------------
  // SEEK (iOS friendly)
  // ------------------------
  function clientXFromEvent(e){
    if (e.touches && e.touches[0]) return e.touches[0].clientX;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
    return e.clientX;
  }

  function onSeekStart(e){
    state.isSeeking = true;
    stopRaf();
    previewAt(clientXFromEvent(e));
    if (e.cancelable) e.preventDefault();
  }

  function onSeekMove(e){
    if (!state.isSeeking) return;
    previewAt(clientXFromEvent(e));
    if (e.cancelable) e.preventDefault();
  }

  function onSeekEnd(e){
    if (!state.isSeeking) return;
    state.isSeeking = false;

    commitAt(clientXFromEvent(e));

    if (!audio.paused && !audio.ended) startRaf();
    if (e.cancelable) e.preventDefault();
  }

  progress.addEventListener('click', function(e){
    e.preventDefault();
    commitAt(e.clientX);
  }, {capture:true});

  // touch
  progress.addEventListener('touchstart', onSeekStart, {passive:false});
  progress.addEventListener('touchmove',  onSeekMove,  {passive:false});
  progress.addEventListener('touchend',   onSeekEnd,   {passive:false});
  progress.addEventListener('touchcancel',onSeekEnd,  {passive:false});

  // mouse
  progress.addEventListener('mousedown', function(e){
    onSeekStart(e);

    function mm(ev){ onSeekMove(ev); }
    function mu(ev){
      onSeekEnd(ev);
      document.removeEventListener('mousemove', mm);
      document.removeEventListener('mouseup', mu);
    }

    document.addEventListener('mousemove', mm);
    document.addEventListener('mouseup', mu);
  });

  // ------------------------
  // AUDIO EVENTS
  // ------------------------
  audio.addEventListener('loadstart', function(){
    setLoading(true);
    setBuffering(true);
    syncGridButtons();
  });

  audio.addEventListener('loadedmetadata', function(){
    setDurationUI();
    setProgressUI();
    setBufferedUI();
    syncGridButtons();
  });

  audio.addEventListener('canplay', function(){
    setBufferedUI();
    settleIfMatches();

    if (state.intentPlay){
      safePlay();
    } else {
      setLoading(false);
      setBuffering(false);
    }
    syncGridButtons();
  });

  audio.addEventListener('playing', function(){
    setPressed(true);
    setLoading(false);
    setBuffering(false);
    startRaf();
    syncGridButtons();
  });

  audio.addEventListener('pause', function(){
    setPressed(false);
    setBuffering(false);
    if (audio.currentTime>0 && !audio.ended) setLoading(false);
    stopRaf();
    syncGridButtons();
  });

  audio.addEventListener('ended', function(){
    setPressed(false);
    setBuffering(false);
    setLoading(false);
    stopRaf();
    hideSticky();                 // авто закрытие
    state.desiredSrc = null;
    syncGridButtons();
  });

  audio.addEventListener('waiting', function(){
    setBuffering(true);
    if (state.intentPlay) setLoading(true);
    syncGridButtons();
  });

  audio.addEventListener('seeking', function(){
    setLoading(true);
    setBuffering(true);
    syncGridButtons();
  });

  audio.addEventListener('seeked', function(){
    setBuffering(false);
    settleIfMatches();
    setProgressUI();
    setBufferedUI();
    if (!state.intentPlay) setLoading(false);
    syncGridButtons();
  });

  audio.addEventListener('timeupdate', function(){
    settleIfMatches();
  });

  audio.addEventListener('progress', function(){
    setBufferedUI();
  });

  audio.addEventListener('error', function(){
    setBuffering(false);
    setLoading(false);

    if (state.src2 && audio.src !== state.src2){
      var wasIntent = state.intentPlay;
      var ct = audio.currentTime || 0;

      audio.src = state.src2;
      audio.load();

      var restore = function(){
        try{ audio.currentTime = Math.min(ct, audio.duration || ct); }catch(e){}
        audio.removeEventListener('loadedmetadata', restore);
      };
      audio.addEventListener('loadedmetadata', restore);

      if (wasIntent) state.intentPlay = true;
    } else {
      state.intentPlay = false;
    }

    syncGridButtons();
  });

  ensureAudioAttrs();
  syncGridButtons();

})();
